<p-toast></p-toast>
<div *ngIf="showForm==true">
    <!-- <img src="./assets/images/logo_with_caption.png" alt="" class="center_logo"> -->
    <app-note-doctors [doctorEdit]="true" [save]="true" [othermedical]="true" [localSave]="true"></app-note-doctors>
    <div class="ui-g-12">
        <div class="ui-g-4" style="display: table; height: 200px; overflow: hidden;">
            <div style="display: table-cell; vertical-align: middle; text-align:center;"><img
                    [src]="(this.avatar_url==null || (this.avatar_url!=null && this.avatar_url.length==0)) ?'./assets/images/default_profile.jpg':this.avatar_url"
                    style="border-radius: 50%;margin-right:auto;margin-left:auto;" height='160' width='160'></div>
        </div>
        <div class="ui-g-4" style="display: table; height: 200px; overflow: hidden;">
            <div style="display: table-cell; vertical-align: middle; text-align:center;">{{this.label | titlecase}}
            </div>
        </div>
    </div>
    <div class="ui-g-12" *ngIf="!this.loading">
        <app-doctor-login-edit-data [editLoginData]="this.editLoginData"></app-doctor-login-edit-data>
    </div>
    <form accept-charset="UTF-8" #otherregistrationform="ngForm" (submit)="submitDoctorRegistration()">
        <div class="ui-g-12">
            <div class="card no-margin">
                <p-fieldset [style]="{'border':'1px solid #000000'}">
                    <p-header><b>Personal Information</b></p-header>
                    <div class="ui-g">
                        <div class="ui-g form-group">
                            <div class="ui-g-12 ui-lg-6">
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="firstname">First Name<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="firstname" type="text" pInputText [pKeyFilter]="name_input"
                                            style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                            name="firstname" [(ngModel)]="this.otherreg.first_name" #firstname="ngModel"
                                            required />
                                        <div *ngIf="!this.otherreg_boolean.first_name" class="alert alert-danger">
                                            First Name is required.
                                        </div>
                                        <div *ngIf="firstname.invalid && (firstname.dirty || firstname.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.first_name && firstname.errors.required"
                                                class="invalid">
                                                First Name is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="middlename">Middle Name</label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="middlename" type="text" pInputText [pKeyFilter]="name_input"
                                            style="width: 260px; color: black; opacity: inherit;"
                                            [(ngModel)]="this.otherreg.middle_name" name="middlename"
                                            #middlename="ngModel" />
                                        <div *ngIf="middlename.invalid && (middlename.dirty || middlename.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="middlename.errors.FieldValidator" class="invalid">
                                                Invalid Middle Name.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="lastname">Last Name<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="lastname" type="text" pInputText [pKeyFilter]="name_input"
                                            style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                            name="lastname" [(ngModel)]="this.otherreg.last_name" #lastname="ngModel"
                                            required />
                                        <div *ngIf="!this.otherreg_boolean.last_name" class="alert alert-danger">
                                            Last Name is required.
                                        </div>
                                        <div *ngIf="lastname.invalid && (lastname.dirty || lastname.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.last_name && lastname.errors.required"
                                                class="invalid">
                                                Last Name is required.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <p-fieldset [style]="{'width':'87%'}">
                                        <p-header><b>Gender</b><span class="doctor-form-req">*</span></p-header>
                                        <div class="ui-g">
                                            <div class="ui-g-12 ui-lg-4" style="width:30%">
                                                <p-radioButton name="gender" value="male" label="Male"
                                                    [(ngModel)]="this.otherreg.gender" #gender="ngModel" required>
                                                </p-radioButton>
                                            </div>
                                            <div class="ui-g-12 ui-lg-4" style="width:30%">
                                                <p-radioButton name="gender" value="female" label="Female"
                                                    [(ngModel)]="this.otherreg.gender" #gender="ngModel" required>
                                                </p-radioButton>
                                            </div>
                                            <div class="ui-g-12 ui-lg-4" style="width:30%">
                                                <p-radioButton name="gender" value="other" label="Other"
                                                    [(ngModel)]="this.otherreg.gender" #gender="ngModel" required>
                                                </p-radioButton>
                                            </div>
                                            <div *ngIf="!this.otherreg_boolean.gender" class="alert alert-danger">
                                                Gender is required.
                                            </div>
                                            <div *ngIf="gender.invalid && (gender.dirty || gender.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.otherreg_boolean.gender && gender.errors.required"
                                                    class="invalid">
                                                    Gender is required.
                                                </div>
                                            </div>
                                        </div>
                                    </p-fieldset>
                                </div>
                            </div>
                            <div class="ui-g-12 ui-lg-6">

                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="date_of_birth">Date Of Birth<span
                                                class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-calendar id="date_of_birth" FieldValidator="Dob" [defaultDate]="dateTime"
                                            [maxDate]="dateTime" class="notranslate" dateFormat="dd/mm/yy" [inputStyle]="{'width': '230px'}"
                                            [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:3099"
                                            [showIcon]="true" placeholder="dd/mm/yyyy"
                                            [(ngModel)]="this.otherreg.date_of_birth_date" name="date_of_birth"
                                            #date_of_birth="ngModel" required></p-calendar>
                                        <div *ngIf="!this.otherreg_boolean.date_of_birth" class="alert alert-danger">
                                            Date Of Birth is required.
                                        </div>
                                        <div *ngIf="date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)"
                                            class="alert alert-danger2">
                                            <div
                                                *ngIf="this.otherreg_boolean.date_of_birth && date_of_birth.errors.required">
                                                Date Of Birth is required.
                                            </div>
                                            <div *ngIf="date_of_birth.errors.FieldValidator">
                                                Invalid Date Of Birth. User must be at least 18.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="language">Language Spoken<span
                                                class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-multiSelect id="language" [filter]="true" [options]="languages"
                                            [(ngModel)]="selected_language" optionLabel="label" name="language"
                                            placeholder="Select"
                                            [style]="{'width': '260px','color': 'black' ,'opacity': 'inherit'}"
                                            #language="ngModel" required></p-multiSelect>
                                        <div *ngIf="!this.otherreg_boolean.language_id" class="alert alert-danger">
                                            Language is required.
                                        </div>
                                        <div *ngIf="language.invalid && (language.dirty || language.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.language_id && language.errors.required"
                                                class="invalid">
                                                Language is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ng-container *ngIf="!editOthers">
                                    <div class="ui-g-12">
                                        <p-checkbox [(ngModel)]="this.changePassword" [value]="changePassword"
                                            [binary]="true" #passwordchange="ngModel" name="passwordchange">
                                        </p-checkbox> Change Password
                                    </div>
                                    <div *ngIf="this.changePassword">
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="previouspassword">Previous Password<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-8 ui-lg-8">
                                                <input pInputText placeholder="Previous Password"
                                                    name="previouspassword"
                                                    style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    [(ngModel)]="otherreg.prev_password" maxlength="25"
                                                    [type]="isPassword?'password':'text'" #prev_password="ngModel">



                                            </div>
                                        </div>
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="password1">Password<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <input placeholder="Password" pInputText
                                                    style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    [type]="isPassword?'password':'text'" [(ngModel)]="password"
                                                    FieldValidator=password name="password1" maxlength="25"
                                                    #password1="ngModel">
                                                <span toggle="#password-field" [ngClass]="{
                                                        'fa fa-fw fa-eye': !isPassword,
                                                        'pi pi-eye-slash': isPassword
                                                      }" style="color:black;margin:auto;padding-left:5px;"
                                                    (click)="changeType()"></span>

                                                <!-- <span toggle="#password-field" class="fa fa-fw fa-eye field_icon " (click)="changeType()" ></span> -->
                                            </div>
                                        </div>
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="confirmpassword">Confirm Password<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-8 ui-lg-6">
                                                <input pInputText placeholder="Confirm Password" name="password2"
                                                    style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    [(ngModel)]="confirmPassword" maxlength="25"
                                                    [type]="isPassword?'password':'text'" #confirmpassword="ngModel">



                                            </div>
                                            <div class="ui-lg-1">
                                            </div>
                                            <div class="ui-lg-1">
                                                <div>
                                                    <div>
                                                        <a style="display: inline-block;" (click)="showTips()">
                                                            <i class class="fa fa-fw fa-question-circle"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>




                                        <div>
                                            <div *ngIf="password1.invalid && (password1.dirty || password1.touched)"
                                                class="alert alert-danger1">
                                                <!-- <div *ngIf="password1.errors.required" class="invalid"> -->
                                                Password is required.
                                                <!-- </div> -->
                                                <div *ngIf="password1.errors.FieldValidator" class="invalid">
                                                    Password should contain minimum 8 characters, at least 1
                                                    Uppercase, 1 Lowercase , 1 Special Character and 1 number.

                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="password!=confirmPassword" class="alert alert-danger1">
                                            <div class="invalid">
                                                Password and Confirm Password do not match.
                                            </div>

                                        </div>

                                        <div *ngIf="confirmpassword.invalid && (confirmpassword.dirty || confirmpassword.touched)"
                                            class="alert alert-danger1 invalid">
                                            <!-- <div *ngIf="confirmpassword.errors.required" class="invalid"> -->
                                            Confirm password is required.
                                            <!-- </div> -->

                                        </div>
                                        <div class="justify-content-center text-center" id="div_content357"
                                            *ngIf="tipsshowed">

                                            <div class="alert alert-danger1">
                                                Password should contain minimum 8 characters, at least 1
                                                Uppercase, 1 Lowecase , 1 Special Character and 1 number.
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </div>
                </p-fieldset>



                <p-fieldset [style]="{'border':'1px solid #000000'}">
                    <p-header><b>Address</b></p-header>
                    <div class="ui-g">
                        <div class="ui-g form-group">
                            <div class="ui-g-12 ui-lg-6">
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="country">Country<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-dropdown id="country" [options]="countries" [(ngModel)]="selectedCountry"
                                            optionLabel="country_name" name="country" placeholder="Select"
                                            [style]="{'color': 'black' ,'opacity': 'inherit'}"
                                            (onChange)="changeStates()" #country="ngModel" required></p-dropdown>
                                        <div *ngIf="!this.otherreg_boolean.country_id" class="alert alert-danger">
                                            Country is required.
                                        </div>
                                        <div *ngIf="country.invalid && (country.dirty || country.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.country_id && country.errors.required"
                                                class="invalid">
                                                Country is required.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="city">City<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="city" type="text" pInputText [pKeyFilter]="city_input"
                                            style="width: 260px; border-color: rgb(16, 151, 16);" name="city"
                                            [(ngModel)]="this.otherreg.city" #city="ngModel" required />
                                        <div *ngIf="!this.otherreg_boolean.city" class="alert alert-danger">
                                            City is required.
                                        </div>
                                        <div *ngIf="city.invalid && (city.dirty || city.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.city && city.errors.required"
                                                class="invalid">
                                                City is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="address1">Address 1<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="address1" type="text" pInputText [pKeyFilter]="address"
                                            style="width: 260px; border-color: rgb(16, 151, 16);" name="address1"
                                            #address_line_1="ngModel" [(ngModel)]="this.otherreg.address_line_1"
                                            #address1="ngModel" required />
                                        <div *ngIf="!this.otherreg_boolean.address_line_1" class="alert alert-danger">
                                            Address is required.
                                        </div>
                                        <div *ngIf="address1.invalid && (address1.dirty || address1.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.address_line_1 && address1.errors.required"
                                                class="invalid">
                                                Address is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="primarycontact">Primary No.<span
                                                class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-4 ui-lg-2">
                                        <input id="primarycontactCode" type="text" pInputText
                                            style="width: 55px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                            name="primarycontactCode" [(ngModel)]="this.selectedPhoneCode_primary"
                                            disabled />
                                    </div>
                                    <div class="ui-g-8 ui-lg-6">
                                        <input id="primaryno" type="text" maxlength=20 pInputText
                                            [pKeyFilter]="phoneNumber"
                                            style="width: 174px; border-color: rgb(16, 151, 16);"
                                            [(ngModel)]="primary_contact_number" name="primaryno" #primaryno="ngModel"
                                            required />
                                        <div *ngIf="!this.otherreg_boolean.primary_contact_number"
                                            class="alert alert-danger">
                                            Primary Phone is required.
                                        </div>
                                        <div *ngIf="primaryno.invalid && (primaryno.dirty || primaryno.touched)">
                                            <div *ngIf="this.otherreg_boolean.primary_contact_number && primaryno.errors.required"
                                                class="invalid">
                                                Primary Phone is required.
                                            </div>

                                        </div>
                                        <!-- <div *ngIf="(primaryno.dirty || primaryno.touched)">
                                            <div class="invalid"
                                                *ngIf="this.otherreg_boolean.primary_contact_number && primary_contact_number?.length!=10">
                                                Phone number should be of 10 digits
                                            </div>
                                        </div> -->
                                    </div>
                                </div>




                            </div>
                            <div class="ui-g-12 ui-lg-6">
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="state">State<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <ng-container>
                                        <div class="ui-g-12 ui-lg-8">
                                            <p-dropdown id="state" [options]="states" [(ngModel)]="selectedState"
                                                optionLabel="state_name" placeholder="Select" name="state"
                                                #state="ngModel" required></p-dropdown>
                                            <div *ngIf="!this.otherreg_boolean.state_name" class="alert alert-danger">
                                                State is required.
                                            </div>
                                            <div *ngIf="state.invalid && (state.dirty || state.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.otherreg_boolean.state_name && state.errors.required"
                                                    class="invalid">
                                                    State is required.
                                                </div>

                                            </div>
                                        </div>
                                    </ng-container>

                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="zip">Zip/Pin Code<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="zip" type="text" pInputText [pKeyFilter]="zipCode"
                                            style="width: 260px; border-color: rgb(16, 151, 16);" name="zip"
                                            [(ngModel)]="this.otherreg.zip_code" #zip="ngModel" required />
                                        <div *ngIf="!this.otherreg_boolean.zip_code" class="alert alert-danger">
                                            Zip/Pin Code is required.
                                        </div>
                                        <div *ngIf="zip.invalid && (zip.dirty || zip.touched)"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.zip_code && zip.errors.required"
                                                class="invalid">
                                                Zip/Pin Code is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="address_line_2">Address 2<span
                                                class="doctor-form-req"></span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="address_line_2" type="text" pInputText [pKeyFilter]="address"
                                            style="width: 260px;" name="address_line_2"
                                            [(ngModel)]="this.otherreg.address_line_2" />
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="secondarycontact">Secondary No.</label>
                                    </div>
                                    <div class="ui-g-4 ui-lg-2">
                                        <input id="secondarycontactCode" type="text" pInputText
                                            style="width: 55px; color: black; opacity: inherit;"
                                            name="secondarycontactCode" [(ngModel)]="this.selectedPhoneCode_secondary"
                                            disabled />
                                    </div>
                                    <div class="ui-g-8 ui-lg-6">
                                        <input id="secondaryno" type="text" maxlength=20 pInputText
                                            [pKeyFilter]="phoneNumber" style="width: 174px;"
                                            [(ngModel)]="secondary_contact_number" name="secondaryno"
                                            #secondaryno="ngModel" />
                                        <!-- <div
                                            *ngIf="(secondaryno.dirty || secondaryno.touched) && secondary_contact_number?.length>0">

                                            <div class="invalid" *ngIf="secondary_contact_number?.length!=10">
                                                Phone number should be of 10 digits
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-fieldset>

                <p-fieldset [style]="{'border':'1px solid #000000'}">
                    <p-header><b>Profile</b></p-header>
                    <div class="ui-g">
                        <div class="ui-g form-group">
                            <div class="ui-g-12 ui-lg-6">
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="primary-occupation">Primary Occupation<span
                                                class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-dropdown id="primary-occupation" name="poccupation" [options]="occupations"
                                            [(ngModel)]="selectedpoccupation" [filter]="true" placeholder="Select"
                                            #pri_occupation="ngModel" required>
                                        </p-dropdown>
                                        <div style="margin-top: 2%;"
                                            *ngIf="getBoolean(this.selectedpoccupation?.toLowerCase(),'others')">
                                            <input id="other_primary" type="text" pInputText
                                                [pKeyFilter]="occupation_input"
                                                style="width: 260px; border-color: rgb(16, 151, 16);"
                                                name="other_Primary" placeholder="Your Occupation"
                                                [(ngModel)]="this.other_primary_occupation" #other_primary="ngModel"
                                                required />
                                        </div>
                                        <div *ngIf="getBoolean(this.selectedpoccupation?.toLowerCase(),'others') && this.othersPrimary_boolean"
                                            class="alert alert-danger">
                                            Enter the Primary Occupation.
                                        </div>
                                        <div *ngIf="!this.otherreg_boolean.primary_occupation"
                                            class="alert alert-danger">
                                            Primary Occupation is required.
                                        </div>
                                        <div *ngIf="(pri_occupation.invalid && (pri_occupation.dirty || pri_occupation.touched))"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.primary_occupation && pri_occupation.errors.required"
                                                class="invalid">
                                                Primary Occupation is required.
                                            </div>
                                        </div>
                                        <!-- <div *ngIf="(other_pri.invalid && (other_pri.dirty || other_pri.touched))"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.primary_occupation && other_pri.errors.required"
                                                class="invalid">
                                                Primary Occupation is required.
                                            </div>
                                        </div> -->

                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="secondary-occupation">Secondary Occupation</label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-dropdown id="secondary-occupation" name="soccupation" [options]="occupations"
                                            [(ngModel)]="selectedsoccupation" [filter]="true" placeholder="Select">
                                        </p-dropdown>

                                        <div style="margin-top: 2%;"
                                            *ngIf="getBoolean(this.selectedsoccupation?.toLowerCase(),'others')">
                                            <input id="other_secondary" type="text" pInputText
                                                [pKeyFilter]="occupation_input" placeholder="Your Occupation"
                                                style="width: 260px; border-color: rgb(16, 151, 16);"
                                                name="other_secondary" [(ngModel)]="this.other_secondary_occupation"
                                                #other_secondary="ngModel" />
                                        </div>
                                        <div *ngIf="getBoolean(this.selectedsoccupation?.toLowerCase(),'others') && this.othersSecondary_boolean"
                                            class="alert alert-danger">
                                            Enter the Secondary Occupation.
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="ui-g-12">
                                    <p>Couldn't find the occupation you're looking for?</p>
                                    <p>(Please type occupation name in input box below and then click on add new
                                        Occupation)</p>
                                </div>


                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="addedOccupation" [pKeyFilter]="blockSpecialCharachters" type="text"
                                            [(ngModel)]="this.addedOccupation" name="addedOccupation"
                                            placeholder="Add New Occupation"
                                            style="width: 209px; border-color: rgb(16, 151, 16);text-transform:capitalize;"
                                            pInputText />
                                    </div>
                                    <div class="ui-g-12 ui-lg-4">
                                        <button type="button" pButton [disabled]="this.addedOccupation.length==0"
                                            (click)="addNewOccupation()" label="Add New Occupation"></button>
                                    </div>
                                </div> -->
                                <div class="ui-g-12">
                                    <div class="ui-g-8 ui-lg-4">
                                        <label for="license_number">License Number</label>
                                    </div>
                                    <div class="ui-g-8 ui-lg-8">
                                        <input id="license_number" [pKeyFilter]="blockSpecialCharachters" type="text"
                                            [(ngModel)]="this.otherreg.license_number" name="license_number"
                                            style="width: 260px; border-color: rgb(16, 151, 16);" pInputText />
                                    </div>
                                </div>

                                <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="experince">Experience in Years<span
                                                class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <input id="experince" type="text" pInputText [pKeyFilter]="number_input"
                                            [(ngModel)]="this.otherreg.years_of_experience"
                                            style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                            name="experince" #experince="ngModel" required />
                                        <div *ngIf="!this.otherreg_boolean.years_of_experience"
                                            class="alert alert-danger">
                                            Experience in Years is required.
                                        </div>
                                        <div *ngIf="(experince.invalid && (experince.dirty || experince.touched))"
                                            class="alert alert-danger">
                                            <div *ngIf="this.otherreg_boolean.years_of_experience  && experince.errors.required"
                                                class="invalid">
                                                Experience in Years is required.
                                            </div>
                                            <!-- <div *ngIf="firstname.errors.FieldValidator" class="invalid">
                                                    Invalid Experience.
                                                </div> -->
                                        </div>
                                    </div>
                                </div>

                                <p-fieldset [style]="{'border':'1px solid #000000'}">
                                    <p-header><b>School/College</b><span class="doctor-form-req">*</span></p-header>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-10">
                                            <!-- <label for="lastname"><b>Medical School</b><span class="doctor-form-req">*</span></label> -->
                                        </div>
                                        <div class="ui-g-12 ui-lg-2">
                                            <button type="button" pButton (click)="showAddSchoolDialog()"
                                                label="Add"></button>
                                        </div>
                                    </div>

                                    <p-dialog [(visible)]="displaySchool" [contentStyle]="{height:'350px'}"
                                        (onHide)="close()" [style]="{width: '50vw'}" header="Add School"
                                        [baseZIndex]="10000">

                                        <div class="ui-g-12">
                                            <div class="card no-margin">
                                                <div class="ui-g">
                                                    <div class="ui-g form-group">
                                                        <div class="ui-g-8 ui-lg-4">
                                                            <label for="School">School/College Name<span
                                                                    class="doctor-form-req">*</span></label>
                                                        </div>
                                                        <div class="ui-g-8 ui-lg-8">
                                                            <input id="School" [pKeyFilter]="blockSpecialCharachters"
                                                                type="text" [(ngModel)]="name" name="School"
                                                                style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                pInputText />
                                                        </div>
                                                        <div class="ui-g-8 ui-lg-4">
                                                            <label for="year_of_graduation">Year of Graduation<span
                                                                    class="doctor-form-req">*</span></label>
                                                        </div>
                                                        <div class="ui-g-8 ui-lg-8">
                                                            <p-dropdown id="year_of_graduation" [options]="years"
                                                                placeholder="Select" filter="true" scrollHeight="150px"
                                                                [showClear]="true" [style]="{'width':'209px'}"
                                                                name="year_of_graduation"
                                                                [(ngModel)]="year_of_graduation"></p-dropdown>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p-footer>
                                            <button pButton type="button" class="ui-button-success" label="Save"
                                                icon="pi pi-save"
                                                [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                (click)="addSchool()"></button>
                                            <button pButton type="button" class="ui-button-warning" label="Cancel"
                                                icon="pi pi-times" (click)="close()"></button>
                                        </p-footer>
                                    </p-dialog>
                                    <p-dialog [(visible)]="editdisplaySchool" [contentStyle]="{height:'350px'}"
                                        (onHide)="this.canceleditData(this.School_edit_id,'School')"
                                        [style]="{width: '50vw'}" header="Edit School" [baseZIndex]="10000">

                                        <div class="ui-g-12">
                                            <div class="card no-margin">
                                                <div class="ui-g">
                                                    <div class="ui-g form-group">
                                                        <div class="ui-g-8 ui-lg-4">
                                                            <label for="School">School/College Name<span
                                                                    class="doctor-form-req">*</span></label>
                                                        </div>
                                                        <div class="ui-g-8 ui-lg-8">
                                                            <input id="School" [pKeyFilter]="blockSpecialCharachters"
                                                                type="text" [(ngModel)]="name" name="School"
                                                                style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                pInputText />
                                                        </div>
                                                        <div class="ui-g-8 ui-lg-4">
                                                            <label for="year_of_graduation">Year of Graduation<span
                                                                    class="doctor-form-req">*</span></label>
                                                        </div>
                                                        <div class="ui-g-8 ui-lg-8">
                                                            <p-dropdown id="year_of_graduation" [options]="years"
                                                                placeholder="Select" filter="true" scrollHeight="150px"
                                                                [showClear]="true" [style]="{'width':'209px'}"
                                                                name="year_of_graduation"
                                                                [(ngModel)]="year_of_graduation"></p-dropdown>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p-footer>
                                            <button pButton type="button" class="ui-button-success" label="Save"
                                                icon="pi pi-save"
                                                [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                (click)="this.saveData(this.School_edit_id,'School')"></button>
                                            <button pButton type="button" class="ui-button-warning" label="Cancel"
                                                icon="pi pi-times"
                                                (click)="this.canceleditData(this.School_edit_id,'School')"></button>
                                        </p-footer>
                                    </p-dialog>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12">
                                            <p-table [value]="School" #dt1 dataKey="si_no"
                                                tablestyleClass="p-datatable-customers" [rows]="3"
                                                [showCurrentPageReport]="true"
                                                [globalFilterFields]="['si_no','name','year']">
                                                <ng-template pTemplate="header">
                                                    <tr>
                                                        <th style="width: 2.5em; text-align: center;">SI No.</th>
                                                        <th>Name</th>
                                                        <th>Year of Graduation</th>
                                                        <th style="width: 8em; text-align: center;">
                                                            <button pButton type="button" icon="pi pi-cog"></button>
                                                        </th>
                                                    </tr>
                                                </ng-template>
                                                <ng-template pTemplate="body" let-product>
                                                    <tr>
                                                        <td style="width: 2.5em; text-align: center;">{{product.si_no}}
                                                        </td>
                                                        <td class="WordWrap format-lines">{{product.name}}</td>
                                                        <td>{{product.year}}</td>
                                                        <td style="width: 8em; text-align: center;">
                                                            <button pButton type="button" class="ui-button-warning"
                                                                icon="pi pi-pencil"
                                                                (click)="editData(product.si_no,'School')"></button>
                                                            <button pButton type="button" class="ui-button-danger"
                                                                icon="pi pi-trash"
                                                                (click)="confirmSchoolSelectDelete($event,product)"
                                                                style="margin-left: .5em"></button>
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </p-table>
                                        </div>
                                    </div>
                                    <div *ngIf="!this.otherreg_boolean.school" class="alert alert-danger">
                                        School/College is required.
                                    </div>
                                </p-fieldset>


                                <p-fieldset [style]="{'border':'1px solid #000000'}">
                                    <p-header><b>Certifications</b></p-header>

                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-10">
                                            <input id="certifications_name" [pKeyFilter]="blockSpecialCharachters"
                                                type="text" [(ngModel)]="this.certifications_name"
                                                name="certifications_name"
                                                style="width: 209px; border-color: rgb(16, 151, 16);" pInputText />
                                        </div>
                                        <div class="ui-g-12 ui-lg-2">
                                            <button type="button" pButton
                                                [disabled]="this.certifications_name.length==0"
                                                (click)="addCertifications()" label="Add"></button>
                                        </div>
                                    </div>

                                    <div class="ui-g-12">
                                        <div class="ui-g-12">
                                            <p-table [value]="Certifications" #dt1 [value]="Certifications"
                                                dataKey="si_no" tablestyleClass="p-datatable-customers" [rows]="3"
                                                [showCurrentPageReport]="true" [globalFilterFields]="['si_no','name']">
                                                <ng-template pTemplate="header">
                                                    <tr>
                                                        <th style="width: 2.5em; text-align: center;">SI No.</th>
                                                        <th>Name</th>
                                                        <th style="width: 8em; text-align: center;">
                                                            <button pButton type="button" icon="pi pi-cog"></button>
                                                        </th>
                                                    </tr>
                                                </ng-template>
                                                <ng-template pTemplate="body" let-product>
                                                    <tr>
                                                        <td style="width: 2.5em; text-align: center;">{{product.si_no}}
                                                        </td>
                                                        <td class="WordWrap format-lines"
                                                            *ngIf="Certifications_edit_id!=product.si_no">
                                                            {{product.name}}
                                                        </td>
                                                        <td *ngIf="Certifications_edit_id==product.si_no">
                                                            <input type="text" style="width:160px;" pInputText
                                                                name="edited_certifications_name"
                                                                [(ngModel)]="this.edited_certifications_name">
                                                        </td>
                                                        <td style="width: 8em; text-align: center;"
                                                            *ngIf="Certifications_edit_id!=product.si_no">
                                                            <button pButton type="button" class="ui-button-warning"
                                                                icon="pi pi-pencil"
                                                                (click)="editData(product.si_no,'Certifications')"></button>
                                                            <button pButton type="button" class="ui-button-danger"
                                                                icon="pi pi-trash"
                                                                (click)="confirmCertificationsSelectDelete($event,product)"
                                                                style="margin-left: .5em"></button>
                                                        </td>
                                                        <td style="width: 8em; text-align: center;"
                                                            *ngIf="Certifications_edit_id==product.si_no">
                                                            <button pButton type="button" class="ui-button-danger"
                                                                icon="pi pi-times"
                                                                (click)="canceleditData(product.si_no,'Certifications')"></button>
                                                            <button pButton type="button" class="ui-button-success"
                                                                icon="pi pi-save"
                                                                (click)="saveData(product.si_no,'Certifications')"
                                                                [disabled]="edited_certifications_name.length==0"
                                                                style="margin-left: .5em"></button>
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </p-table>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <p-fieldset [style]="{'border':'1px solid #000000'}">
                                    <p-header><b>Affiliated Hospitals</b></p-header>

                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-10">
                                            <input id="affiliatedhospitals_name" [pKeyFilter]="blockSpecialCharachters"
                                                type="text" [(ngModel)]="this.hospitals_name"
                                                name="affiliatedhospitals_name"
                                                style="width: 209px; border-color: rgb(16, 151, 16);" pInputText />
                                        </div>
                                        <div class="ui-g-12 ui-lg-2">
                                            <button type="button" pButton [disabled]="this.hospitals_name.length==0"
                                                (click)="addAffiliatedHospitals()" label="Add"></button>
                                        </div>
                                    </div>

                                    <div class="ui-g-12">
                                        <div class="ui-g-12">
                                            <p-table [value]="Hospitals" #dt1 [value]="Hospitals" dataKey="si_no"
                                                tablestyleClass="p-datatable-customers" [rows]="3"
                                                [showCurrentPageReport]="true" [globalFilterFields]="['si_no','name']">
                                                <ng-template pTemplate="header">
                                                    <tr>
                                                        <th style="width: 2.5em; text-align: center;">SI No.</th>
                                                        <th>Name</th>
                                                        <th style="width: 8em; text-align: center;">
                                                            <button pButton type="button" icon="pi pi-cog"></button>
                                                        </th>
                                                    </tr>
                                                </ng-template>
                                                <ng-template pTemplate="body" let-product>
                                                    <tr>
                                                        <td style="width: 2.5em; text-align: center;">{{product.si_no}}
                                                        </td>
                                                        <td class="WordWrap format-lines"
                                                            *ngIf="hospitals_edit_id!=product.si_no">{{product.name}}
                                                        </td>
                                                        <td *ngIf="hospitals_edit_id==product.si_no">
                                                            <input type="text" style="width:160px;" pInputText
                                                                name="edited_affiliatedhospitals_name"
                                                                [(ngModel)]="this.edited_hospitals_name">
                                                        </td>
                                                        <td style="width: 8em; text-align: center;"
                                                            *ngIf="hospitals_edit_id!=product.si_no">
                                                            <button pButton type="button" class="ui-button-warning"
                                                                icon="pi pi-pencil"
                                                                (click)="editData(product.si_no,'Hospitals')"></button>
                                                            <button pButton type="button" class="ui-button-danger"
                                                                icon="pi pi-trash"
                                                                (click)="confirmAffiliatedHospitalsSelectDelete($event,product)"
                                                                style="margin-left: .5em"></button>
                                                        </td>
                                                        <td style="width: 8em; text-align: center;"
                                                            *ngIf="hospitals_edit_id==product.si_no">
                                                            <button pButton type="button" class="ui-button-danger"
                                                                icon="pi pi-times"
                                                                (click)="canceleditData(product.si_no,'Hospitals')"></button>
                                                            <button pButton type="button" class="ui-button-success"
                                                                icon="pi pi-save"
                                                                (click)="saveData(product.si_no,'Hospitals')"
                                                                [disabled]="edited_hospitals_name.length==0"
                                                                style="margin-left: .5em"></button>
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </p-table>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <div class="ui-g-12">
                                    <p-checkbox [(ngModel)]="this.changePhoto" [value]="this.changePhoto"
                                        [binary]="true" #photochange="ngModel" name="photochange"></p-checkbox>
                                    Change Profile Photo
                                </div>
                                <div *ngIf="this.changePhoto">
                                    <div class="ui-g-12">
                                        <div class="ui-g-12">
                                            <p-fieldset styleClass="sample-photo-fieldset">
                                                <p-header>
                                                    Sample Profile Photo
                                                </p-header>
                                                <img src="./assets/images/samplePhotos/doc001.jpg" alt="Sample Photo"
                                                    class="sample-photo-doctor-registration">
                                                <img src="./assets/images/samplePhotos/doc002.jpg" alt="Sample Photo"
                                                    class="sample-photo-doctor-registration">
                                                <div class="ui-g-12" style="text-align: center;font-weight: bold;">
                                                    Recommended Image Dimensions
                                                    <p>800 pixels X 850 pixels</p>
                                                </div>
                                            </p-fieldset>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12">
                                            <label for="photot">Profile Photo<span
                                                    class="doctor-form-req">*</span></label>
                                            <ng-container *ngIf="this.avatar_url!=null && this.avatar_url.length>0">
                                                <a href="javascript:void(0)" style="cursor:pointer"
                                                    (click)="download(this.avatar_url,'Profile_Photo')">
                                                    Download Profile Photo
                                                </a>
                                            </ng-container>
                                            <ng-container *ngIf="this.avatar_url==null ||  this.avatar_url?.length==0">
                                                No Profile Photo Uploaded
                                            </ng-container>
                                            <!-- <input pButton type="button" label="Download Profile Photo" (onClick)="download(this.avatar_url)"> -->
                                        </div>
                                        <div class="ui-g-12">
                                            <p-fileUpload name="photo" id="photo" (onRemove)="onRemovePhoto()"
                                                (onSelect)="uploadProfileFiles($event.files)"
                                                styleClass="p-fileUpload-label-fix" [showCancelButton]="false"
                                                [showUploadButton]="false" [maxFileSize]="5033165" multiple="false"
                                                [fileLimit]="1" accept="image/*">
                                            </p-fileUpload>
                                        </div>
                                    </div>
                                    <div *ngIf="!this.otherreg_boolean.profile_photo" class="alert alert-danger">
                                        Profile Photo is required.
                                    </div>
                                    <div class="alert alert-danger" role="alert">
                                        <p class="text-center text-gray-underline"><span
                                                class="font-weight-bold">Note</span>: The
                                            file type supported for Profile Photo are JPEG,JPG,PNG.</p>
                                    </div>
                                </div>

                                <div class="ui-g-12" *ngIf="!this.editOthers">
                                    <p-checkbox [(ngModel)]="this.changeResume" [value]="this.changeResume"
                                        [binary]="true" #resumechange="ngModel" name="Resumechange">
                                    </p-checkbox>
                                    Change Resume
                                </div>
                                <div *ngIf="this.changeResume">
                                    <div class="ui-g-12">
                                        <div class="ui-g-12">
                                            <label for="zip">Resume/CV<span class="doctor-form-req">*</span></label>
                                            <ng-container *ngIf="this.resume_url!=null && this.resume_url.length>0">
                                                <a href="javascript:void(0)" style="cursor:pointer"
                                                    (click)="download(this.resume_url,'Resume')">
                                                    Download Resume
                                                </a>
                                            </ng-container>
                                            <ng-container *ngIf="this.resume_url==null ||  this.resume_url?.length==0">
                                                No Resume File Uploaded
                                            </ng-container>
                                        </div>
                                        <div class="ui-g-12">
                                            <p-fileUpload name="resume" id="resume" (onRemove)="onRemoveResume()"
                                                styleClass="p-fileUpload-label-fix"
                                                (onSelect)="uploadResumeFiles($event.files)" [showUploadButton]="false"
                                                [showCancelButton]="false" [maxFileSize]="5033165" multiple="false"
                                                [fileLimit]="1" accept=".pdf">
                                            </p-fileUpload>
                                        </div>
                                    </div>
                                    <div *ngIf="!this.otherreg_boolean.resume_cv" class="alert alert-danger">
                                        Resume/CV is required.
                                    </div>
                                    <div class="alert alert-danger" role="alert">
                                        <p class="text-center text-gray-underline"><span
                                                class="font-weight-bold">Note</span>: The
                                            file type supported for Resume/CV is PDF.</p>
                                    </div>
                                </div>
                                <div class="ui-g-12">
                                    <label for="Description">Description about yourself (Bio) <span
                                            class="doctor-form-req">*</span>:</label>
                                </div>
                                <!-- <div class="ui-g-12"> -->
                                <div class="ui-g-12">
                                    <textarea [pKeyFilter]="textarea" [(ngModel)]="otherreg.description"
                                        name="Description" id="Description"
                                        class="WordWrap format-lines textarea-doctor-registration" maxlength="5000"
                                        pInputTextarea #Description="ngModel" required></textarea>
                                    <div *ngIf="!this.otherreg_boolean.description" class="alert alert-danger">
                                        Description about yourself is mandatory.
                                    </div>
                                    <div *ngIf="Description.invalid && (Description.dirty || Description.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="this.otherreg_boolean.description && this.Description.errors.required"
                                            class="invalid">
                                            Description about yourself is mandatory.
                                        </div>
                                    </div>

                                </div>
                                <div class="ui-g-12" style="float: left;">
                                    <p [style.color]="otherreg.description.length-4999>0?'red':'green'"
                                        style="float: left;">
                                        {{(5001-otherreg.description.length)<0?0:5000-otherreg.description.length}} of
                                            5000 left</p>

                                </div>

                            </div>
                        </div>
                    </div>
                </p-fieldset>
            </div>
        </div>

        <div>
            <div id="recaptcha-div2">
                <re-captcha *ngIf="recaptcha_Reset" class="recaptcha ng-valid" name="recaptcha" matInput
                    style="display: inline-block;" (resolved)="resolved($event)" [(ngModel)]="otherreg.recaptcha"
                    #recaptcha="ngModel" [siteKey]="sitekey" required>
                </re-captcha>
            </div>

            <div *ngIf="!this.otherreg_boolean.recaptcha" class="alert alert-danger">
                Recaptcha is required.
            </div>
        </div>

        <!-- <div class="container text-center justify-content-center">
            <p style="padding-left:25%;">
                <p-checkbox name="agree" [(ngModel)]="agree" (onChange)="onAgreeChange($event)" [binary]="true">
                </p-checkbox>
                <span style="padding-left: 2%;">I agree that above information are accurate to best of my
                    knowledge</span>
            </p>
            <div *ngIf="!this.otherreg_boolean.agree" style="padding-left:25%;" class="alert alert-danger">
                Agree is required.
            </div>
        </div> -->

        <div class="ui-g-12">
            <div class="row container justify-content-center text-center alert alert-danger"
                *ngIf="error_message_result?.success!=null && error_message_result?.success==false && error_message_result?.data!=null && error_message_result?.data.length>0">
                <p>Following fields are not filled:</p>
                <p *ngFor="let message of error_message_result.data ;let i = index">{{(i+1) +". "+ message}}</p>
            </div>
        </div>
        <div class="ui-g-12">
            <div class="row container justify-content-center text-center alert alert-danger"
                *ngIf="response.success!=null && response.success==false">
                <p *ngIf="response.error!=null">{{response.error.message}}</p>
                <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                    <p *ngFor="let message of serverError?.message">{{message}}</p>
                </div>
                <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                    <p>{{serverError?.message}}</p>
                </div>

            </div>
        </div>
        <!-- [disabled]="this.School.length==0
                                                ||!otherregistrationform.valid
                                                ||!this.agree
                                                ||this.posting" -->
        <div style="align-items: center;">
            <p-progressSpinner *ngIf="this.posting"
                [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
            </p-progressSpinner>
            <!-- <p-button type="button" [style]="{'margin-left':'5%','align-items':'center'}" 
        label="Save" [disabled]="this.posting"  class="p-button-lg"></p-button> -->
            <p-button type="submit" [style]="{'margin-left':'10%','align-items':'center'}" label="Update"
                class="p-button-lg" [disabled]="this.posting" icon="pi pi-check"></p-button>
            <!-- <p-button type="submit"  [style]="{'align-items':'center'}"  label="Register" class="p-button-lg" icon="pi pi-check"></p-button> -->
            <p-button type="button" [style]="{'margin-left':'20%','align-items':'center'}" (click)="gotodashboard()"
                label="Cancel" [disabled]="this.posting" class="p-button-lg"></p-button>
        </div>

    </form>
    <div class="mat-elevation-z8">
        <p-confirmDialog key="confirm-delete-School" header="Delete School" acceptLabel="Yes" rejectLabel="No"
            [(visible)]="confirmDialogVisible1"></p-confirmDialog>
    </div>

    <p-dialog [(visible)]="noteDialog" [style]="{width: '80vw'}" (onHide)="RestoreData()"
        header="Please read before filling the form" [baseZIndex]="10000">
        <app-note-doctors [doctorEdit]="true" [save]="true" [othermedical]="true" [localSave]="true"></app-note-doctors>
        <button pButton type="button" class="ui-button-success" label="Close" icon="pi pi-times"
            (click)="this.noteDialog=false"
            style="display:flex;margin-left:auto;margin-right:auto;margin-top:3%;"></button>
    </p-dialog>

    <div class="mat-elevation-z8">
        <p-confirmDialog key="confirm-delete-College" header="Delete College" acceptLabel="Yes" rejectLabel="No"
            [(visible)]="confirmDialogVisible2"></p-confirmDialog>
    </div>
    <div class="mat-elevation-z8">
        <p-confirmDialog key="confirm-delete-certifications" header="Delete Certification" acceptLabel="Yes"
            rejectLabel="No" [(visible)]="confirmDialogVisible3"></p-confirmDialog>
    </div>
    <div class="mat-elevation-z8">
        <p-confirmDialog key="confirm-delete-affiliatedhospitals" header="Delete Affiliated Hospital" acceptLabel="Yes"
            rejectLabel="No" [(visible)]="confirmDialogVisible4"></p-confirmDialog>
    </div>

</div>

<div *ngIf="success_register_display">
    <p-dialog header="Profile Update Successful" [(visible)]="success_register_display"
        [style]="{'width': '50vw','text-align':'center'}">
        <!-- <p>Successfully registered</p> -->
        <p>Profile has been updated Successfully</p>
        <p *ngIf="this.changePassword">Password has also been updated Successfully.</p>
        <!-- <p *ngIf="this.changePin">Pin has also been updated Successfully.</p> -->
        <p *ngIf="this.resume_result">Resume has also been updated Successfully.</p>
        <!-- <p *ngIf="this.profile_result">Profile photo has also been updated Successfully.</p> -->
        <!-- <p *ngIf="this.sig_result">Signature has also been updated Successfully.</p> -->
        <p-button label="Go to Dashboard" (click)="gotodashboard()"></p-button>
    </p-dialog>
</div>